<template>
    <div>
        <BuzzerButton class="buzzerButton" ref="buzzer" @mousedown="startClicking" @click="clicked" />
        <p v-if="hasRecentDetection || isSigningUp" class="confirmation">Je toetje is binnengekomen!</p>
    </div>
</template>

<script setup>
import { ref } from 'vue';
import BuzzerButton from '../assets/images/buzzerButton.svg'
import { useBuzzerStore } from '../stores/buzzerStore';
import { storeToRefs } from 'pinia';


const store = useBuzzerStore();
const { hasRecentDetection, isSigningUp } = storeToRefs(store);

const buzzer = ref(null);

const startClicking = () => {
    buzzer.value.$el.classList.add('clicked');
}

const clicked = () => {
    store.signUp();
    buzzer.value.$el.classList.remove('clicked');
}
</script>

<style lang="scss" scoped>
.buzzerButton {
    margin-top: 20px;
    width: 100%;
    user-select: none;

    &:hover {
        cursor: pointer;
    }

    &.clicked {
        transform: scale(0.95);
    }


    :deep(#b) {
        display: block;

        background: linear-gradient(to top, rgba(255, 0, 0, 0.5), rgba(255, 0, 0, 0) 50%);
        background-blend-mode: overlay;
    }

    @keyframes colorOverlay {
        0% {
            background: none;
        }

        50% {
            background: linear-gradient(to top, rgba(255, 0, 0, 0.5), rgba(255, 0, 0, 0) 50%);
            background-blend-mode: overlay;
        }

        100% {
            background: rgba(255, 0, 0, 0.5);
            background-blend-mode: overlay;
        }
    }
}

.confirmation {
    font-size: 1.5rem;
    text-align: center;
    margin-top: 20px;
    font-family: 'Qarla';
}
</style>